import { request } from '../lib/request';
import type { ApiRequestBody, ApplePaySessionParams } from '../types';

export const createPayload = (params: ApplePaySessionParams): ApiRequestBody => ({
    endpoint_url: params.validationURL,
    purchase_token: params.purchaseToken,
    merchant_id: params.merchantId,
});

export const applePaySessionApi = (apiHost: string, params: ApplePaySessionParams) =>
    request({
        method: 'GET',
        url: `${apiHost}/web/apple_pay_session`,
        params: createPayload(params),
        contentType: null,
    });
